<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm02_title"></a><a id="page_iii"></a>The Indians of Texas</h1>
<p class="subtitle1"><em>From Prehistoric to Modern Times</em></p>
<p class="author">by W. W. Newcomb, Jr.</p>
<p class="author1"><em>with drawings by Hal M. Story</em></p>
<p class="pub"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_title.vue?00660edd